import { render, staticRenderFns } from "./IconOpen.vue?vue&type=template&id=48c35790&"
import script from "./IconOpen.vue?vue&type=script&lang=js&"
export * from "./IconOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c35790')) {
      api.createRecord('48c35790', component.options)
    } else {
      api.reload('48c35790', component.options)
    }
    module.hot.accept("./IconOpen.vue?vue&type=template&id=48c35790&", function () {
      api.rerender('48c35790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconOpen.vue"
export default component.exports